<template>
    <div>
        <b-modal id="confirm-info" hide-footer centered>
            <template #modal-title>
                <h6>Xác nhận</h6>
            </template>
            <div class="d-block text-center">
                <p>Chúng tôi sẽ thông báo kết quả kiểm tra năng lực qua SĐT và Email. Bạn có chắc chắn
                    <code>{{ form.phone }}</code> là số của bạn</p>

                <b-form-group v-if="reInputPhone" id="input-group-3" label-for="input-2">
                    <b-form-input class="border" id="input-2" v-model="form.confirmPhone" name="phone" ref="phone"
                        :state="confirmPhoneState" placeholder="* Hãy nhập số điện thoại của bạn" required autofocus />
                </b-form-group>
                <b-form-invalid-feedback v-if="reInputPhone" :state="confirmPhoneState">Bạn vui lòng nhập đúng số điện
                    thoại</b-form-invalid-feedback>
                <b-button class="mb-3" variant="primary" block @click="btnPushContactNoLogin()">Xác nhận</b-button>
                <span v-if="!reInputPhone"
                    style="cursor: pointer; color: rgb(162, 10, 10); font-weight: 700; display: block; border: 1px solid; width: -webkit-fit-content; width: -moz-fit-content; width: fit-content; margin: auto; padding: 10px; border-radius: 5px;"
                    @click="reInputPhone = true">Số của tôi là số khác</span>
            </div>
        </b-modal>

        <div v-if="!error.msg">
            <div v-if="inputType == 'ican_connect'" class="mt-4">
                <b-container v-if="contactInfo.id == -1">
                    <div class="title-form ">
                        <h5 class="mb-4">Xin chào! hãy cùng bắt đầu nào.</h5>
                    </div>
                    <div class="form-info">
                        <b-form>
                            <div class="w-100 text-center">
                                <GeLogin />
                            </div>
                        </b-form>
                    </div>
                </b-container>
                <b-container v-if="contactInfo.id != -1">
                    <div class="title-form ">
                        <h5 class="mb-4">Xin chào {{ contactInfo.name || contactInfo.email }}!</h5>
                    </div>
                    <div class="form-info">
                        <b-form>
                            <div class="w-100 text-center">
                                <b-button @click="btnPushContactLogin()" variant="success"
                                    class="btn-custom w-100 mb-3 fz-20">TIẾP TỤC</b-button>
                                <b-button @click="logout()" variant="danger" class="btn-custom w-100 fz-20">THAY ĐỔI THÔNG TIN</b-button>
                            </div>
                        </b-form>
                    </div>
                </b-container>
            </div>
            <div v-if="inputType == 'form_input'">
                <b-container>
                    <div class="title-form " hidden>
                        <h5 class="mb-4">Để bắt đầu bài kiểm tra, bạn vui lòng trả lời các câu hỏi sau:</h5>
                    </div>
                    <div class="form-info" v-if="form.step == 1">
                        <b-form @submit="onSubmit">
                            <b-form-group id="input-group-1" :label-for="input.id" v-for="(input, index) in inputConfig.form_input" :key="input.name">
                                <b-form-input
                                    :id="input.id"
                                    :autofocus="index == 0"
                                    v-model="form[input.name]"
                                    :state="checkStage(input)"
                                    :name="input.name"
                                    :ref="input.name"
                                    :placeholder="input.placeholder"
                                    :required="input.required"
                                    :type="input.type"
                                />
                                <b-form-invalid-feedback :state="checkStage(input)">{{ getErrorMsg(input) }}</b-form-invalid-feedback>
                            </b-form-group>
                            
                            <div class="w-100 text-center">
                                <b-button @click="checkStep1()" variant="success" class="btn-custom btn-next">Next</b-button>
                                <!-- <b-button @click="form.step = 0" variant="primary">Previous</b-button> -->
                            </div>
                        </b-form>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>


import GeLogin from '@/components/GELogin.vue'

export default {
    data () {
        return {
            nextButtonPress: false,
            startButtonPress: false,
            reInputPhone: false,
            form: {},
        }
    },
    props: {
        value: {
            type: Object
        },
        step: {
            type: Number,
            default: 1,
        }
    },
    created() {
        this.form = this.value
    },
    components: {
        GeLogin
    },
    methods: {
        checkStage(input) {
            if (!this.nextButtonPress) {
                return null
            }

            const value = this.$refs[input.name][0].value ?? ''
            if (
                input.required &&
                (value.trim() === '' || value.trim() === ' ')
            ) {
                return false
            }

            if (
                (input.name == 'phone' || input.name == 'sdt') &&
                !this.checkPhone(value.trim())
            ) {
                return false 
            }

            if (
                (input.name == 'email') &&
                !this.validEmail(value.trim())
            ) {
                return false 
            }

            return true
            
        },
        getErrorMsg (input) {
            if (!this.nextButtonPress) {
                return null
            }
            
            const value = this.$refs[input.name][0].value ?? ''
            if (
                input.required &&
                (value.trim() === '' || value.trim() === ' ')
            ) {
                return input.require_msg
            }

            if (
                (input.name == 'phone' || input.name == 'sdt') &&
                !this.checkPhone(value.trim())
            ) {
                return 'Số điện thoại không đúng định dạng!' 
            }

            if (
                (input.name == 'email') &&
                !this.validEmail(value.trim())
            ) {
                return "Email không đúng định dạng!"
            }
        },
        onSubmit(event) {
            event.preventDefault()
            alert(JSON.stringify(this.form))
        },
        
        
        btnPushContactLogin() {
            this.pushContact({
                source: document.location.href,
                ctid: this.contactInfo.id
            })
        },
        checkStep2() {
            if (this.form.examchoose != 2) {
                
                if (this.form.examchoose == 0) {
                    this.form.level = 2
                }
                
                if (this.form.examchoose == 1) {
                    this.form.level = 1
                }

                this.btnPushContactNoLogin()
            } else {
                this.$emit('change-step', 3)
            }
        },
        checkStep3() {
            if (this.form.examchoose2 != 4) {
                this.form.level = 1
            } else {
                this.form.level = 2
            }
            this.btnPushContactNoLogin()
        },
        btnPushContactNoLogin () {

            this.startButtonPress = true;
            if (this.reInputPhone && this.confirmPhone && this.confirmPhone !== '') {
                this.form.phone = this.confirmPhone
            }

            this.pushContact(this.form)
        },
        pushContact(data){

            this.$TestApp.pushContactAndCreateTest(data)
            .then(() => {})
            .catch(error => {
                this.$bvToast.toast(error.message, {
                    title: `Có lỗi xảy ra !`,
                    variant: 'danger',
                    solid: true
                })
            })
            
        },
        checkStep1 () {
            this.nextButtonPress = true;

            for (let index = 0; index < this.inputConfig.form_input.length; index++) {
                const input = this.inputConfig.form_input[index];
                if (!this.checkStage(input)) {
                    this.$refs[input.name][0].focus()
                    return
                }
            }

            this.reInputPhone = false
            this.$bvModal.show('confirm-info')
        },

        
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        checkPhone(mobile) {
            let vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
            if(mobile !==''){
                if (vnf_regex.test(mobile) == false) {
                    return false
                } else {
                    return true
                }
            }
        },
    },
    computed: {
        nameSate() {
            if (!this.nextButtonPress) {
                return null
            }
            let nameSplit = this.form.name.split('')
            if(nameSplit[0] == ' ' || nameSplit[nameSplit.length - 1] == ' ' || this.form.name.trim().length == '' || !/[A-Z, a-z]/.test(this.form.name)){
                return false;
            } else {
                return true
            }
        },
        ageState() {
            if (!this.nextButtonPress) {
                return null
            }
            let ageSplit = this.form.age.split('')
            if(!(ageSplit[0] == ' ' || ageSplit[ageSplit.length - 1] == ' ') && this.form.age.trim().length > 0 && this.form.age.trim().length < 3 && /^[0-9 ]*$/.test(this.form.age) && parseInt(this.form.age) > 0){
                return true
            } else {
                return false;
            }
        },
        emailState(){
            let emailSplit = this.form.email.split('')
            if(emailSplit[0] == ' ' || emailSplit[emailSplit.length - 1] == ' ' || !this.validEmail(this.form.email.trim())){
                return false;
            } else {
                return true
            }
        },
        phoneState(){
            let phoneSplit = this.form.phone.split('')
            if(phoneSplit[0] == ' ' || phoneSplit[phoneSplit.length - 1] == ' ' || !this.checkPhone(this.form.phone)){
                return false;
            } else {
                return true
            }
        },
        confirmPhoneState(){
            let phoneConfirmSplit = this.form.confirmPhone.split('')
            if(phoneConfirmSplit[0] == ' ' || phoneConfirmSplit[phoneConfirmSplit.length - 1] == ' ' || !this.checkPhone(this.form.confirmPhone)){
                return false;
            } else {
                return true
            }
        },

        error() {
            return this.$TestApp.getError()
        },
        inputType () {
            return this.$TestApp.getStartType()
        },
        inputConfig () {
            return this.$TestApp.getStartWith()
        },
        
        contactInfo() {
            return this.$TestApp.getContactInfo()
        },
    }
}

</script>


<style>

form.qanda select:focus {
        outline: none;
        border: none;
        box-shadow: none;
    }

    form.qanda .custom-control-input {
        position: inherit !important;
        border: none !important;
    }

    form.qanda .custom-control-label {
        padding-left: 10px !important;
    }

    form.qanda {
        /* width: 640px; */
        margin: auto;
    }

    form.qanda select {
        width: 300px;
        font-weight: 600;
        color: #000;
        border: none;
        border-radius: 7px;
    }

    form.qanda .form-group>label {
        font-size: 20px;
        color: #fff;
        line-height: 24px;
        margin-bottom: 5px;
    }

    form.qanda .custom-radio {
        background-color: #fff;
        padding: 7px 10px;
        height: 100% !important;
        width: 100% !important;
        border-radius: 7px;
        font-weight: 600;
        margin-top: 20px;
        display: inline-flex;
    }

    .invalid-feedback {
        display: none;
        width: 100%;
        margin-top: -10px;
        margin-bottom: 11px;
        font-weight: 700;
        font-size: 16px;
        color: #dc3545;
    }
    input[type=radio].is-invalid{
        background-color: #dc3545;
    }
    .checkbox-form .checkbox>div {
        padding: 0;
        margin: 0;
        margin-top: 6px;
    }

    .checkbox-form .checkbox>div input {
        display: inline;
        width: 100%;
        height: 15px;
        top: -13px;
    }

    .checkbox-form .checkbox>div label {
        display: block;
        width: 100%;
    }

    .custom-select {
        display: inline-block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem 1.75rem .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        vertical-align: middle;
        background: #fff url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center/8px 10px;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    .custom-control-label:before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    

    .title-form h5{
        text-align: center;
        color: white;
        font-weight: 700;
        margin-top: 15px;
    }
    .form-control {
        border-radius: 15px;
        color: #0158a8;
        line-height: 1.5;
        margin-bottom: 20px;
        font-weight: 600;
        box-shadow: 0px 4px 3px #1b96f2;
        height: 50px;
        padding: 15px;
    }
    .form-control::-webkit-input-placeholder {
        color: #0158a8;
    }

    .form-info{
        width: 45%;
        max-width: 450px;
        margin: auto;
    }


    @media only screen and (max-width: 1200px){
        .form-info {
            width: 50%;
        }
    }

    @media only screen and (max-width: 992px){
        .form-info {
            width: 65%;
        }
    }

    @media only screen and (max-width: 768px) {
        .form-info {
            width: 100%;
        }
    }
</style>